import type { ReactNode } from 'react';

import { SiteFooter } from '@/components/SiteFooter';

type AppShellProps = {
  children: ReactNode;
};

/**
 * Full-height shell: growing main + platform-style footer pinned to the bottom.
 */
export function AppShell({ children }: AppShellProps) {
  return (
    <div
      data-testid="demo-app-shell"
      className="flex min-h-[100dvh] flex-col bg-slate-50 dark:bg-slate-950"
    >
      <main className="flex flex-1 flex-col">{children}</main>
      <SiteFooter />
    </div>
  );
}
